import type { GA4EventName } from './ga4Events';
import type { ProfileEventData } from '@rango-dev/internal-profile';

import { ProfileEventTypes } from '@rango-dev/internal-profile';

import { pushToDataLayer } from './dataLayer';
import { GA4Events } from './ga4Events';

/**
 * Maps the profile package's semantic login/merge events to their GA4 event
 * names. The profile package is analytics-agnostic; this is the single place
 * the dapp translates its events into dataLayer pushes.
 */
const PROFILE_EVENT_TO_GA4: Record<ProfileEventTypes, GA4EventName> = {
  [ProfileEventTypes.LOGIN_INITIATED]: GA4Events.PROFILE_LOGIN_INITIATED,
  [ProfileEventTypes.LOGIN_COMPLETED]: GA4Events.PROFILE_LOGIN_COMPLETED,
  [ProfileEventTypes.LOGIN_FAILED]: GA4Events.PROFILE_LOGIN_FAILED,
  [ProfileEventTypes.MERGE_INITIATED]: GA4Events.PROFILE_MERGE_INITIATED,
  [ProfileEventTypes.MERGE_COMPLETED]: GA4Events.PROFILE_MERGE_COMPLETED,
  [ProfileEventTypes.MERGE_FAILED]: GA4Events.PROFILE_MERGE_FAILED,
};

export function handleProfileEvent(data: ProfileEventData): void {
  pushToDataLayer(PROFILE_EVENT_TO_GA4[data.type], {
    wallet_name: data.payload.walletName,
  });
}
